import { CollapseIconPosition, ProgressIconPosition } from '@vedalib/editor/lib/elements'
import { chainName } from 'utils'

import { genElementValueField } from 'components/Editor/Toolbar/NodeForm/genElementValueField'
import Padding from 'components/Editor/Toolbar/Padding'
import { FieldSegmented, FieldSelect, FormField } from 'components/formKit'
import { t } from 'services/Translation'
import { getEnumOption } from 'utils/enum'

import type { CourseStructureFormValueType } from './courseStructureTypes'

const SHOW_DESCRIPTION = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'showDescription',
  label: t('elements.courseStructure.form.showDescription'),
  defaultValue: false,
})

const SHOW_CHAPTER_ICON = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'showChapterIcon',
  label: t('elements.courseStructure.form.showChapterIcon'),
  defaultValue: false,
})

const SHOW_LANDING_ICON = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'showLandingIcon',
  label: t('elements.courseStructure.form.showLandingIcon'),
  defaultValue: false,
})

const SHOW_TEST_ICON = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'showTestIcon',
  label: t('elements.courseStructure.form.showTestIcon'),
  defaultValue: false,
})

const INITIAL_OPEN = genElementValueField({
  as: FieldSegmented<boolean>,
  name: 'initialOpen',
  label: t('elements.courseStructure.form.open'),
  defaultValue: false,
})

const PROGRESS_POSITION = genElementValueField({
  name: 'progressPosition',
  as: FieldSelect<ProgressIconPosition>,
  label: t('input.label.progress'),
  props: {
    fluid: true,
    options: [
      getEnumOption('ProgressIconPosition', ProgressIconPosition.none),
      getEnumOption('ProgressIconPosition', ProgressIconPosition.left),
      getEnumOption('ProgressIconPosition', ProgressIconPosition.right),
    ],
  },
})

const COLLAPSE_POSITION = genElementValueField({
  name: 'collapsePosition',
  as: FieldSelect<CollapseIconPosition>,
  label: t('elements.courseStructure.form.collapse'),
  props: {
    fluid: true,
    options: [
      getEnumOption('CollapseIconPosition', CollapseIconPosition.none),
      getEnumOption('CollapseIconPosition', CollapseIconPosition.leftOutside),
      getEnumOption('CollapseIconPosition', CollapseIconPosition.left),
      getEnumOption('CollapseIconPosition', CollapseIconPosition.right),
      getEnumOption('CollapseIconPosition', CollapseIconPosition.rightOutside),
    ],
  },
})

const CourseStructureFormValue: CourseStructureFormValueType = ({ name }) => {
  return (
    <Padding bottom gap sides>
      <FormField config={chainName(name, SHOW_DESCRIPTION)} />
      <FormField config={chainName(name, SHOW_CHAPTER_ICON)} />
      <FormField config={chainName(name, SHOW_LANDING_ICON)} />
      <FormField config={chainName(name, SHOW_TEST_ICON)} />
      <FormField config={chainName(name, INITIAL_OPEN)} />
      <FormField config={chainName(name, PROGRESS_POSITION)} />
      <FormField config={chainName(name, COLLAPSE_POSITION)} />
    </Padding>
  )
}

export default CourseStructureFormValue
